'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2.98023e-06C9.33333 -2.80836e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V2.98023e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V0L0 2.98023e-06V20Z",
          fill: "#30C375"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M4 0H8V20H4V0Z", fill: "#DE414F" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 4C7.10457 4 8 3.40305 8 2.66667C8 1.93029 7.10457 1.33333 6 1.33333C4.89543 1.33333 4 1.93029 4 2.66667C4 3.40305 4.89543 4 6 4Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00016 3.33335C6.36835 3.33335 6.66683 3.03488 6.66683 2.66669C6.66683 2.2985 6.36835 2.00002 6.00016 2.00002C5.63197 2.00002 5.3335 2.2985 5.3335 2.66669C5.3335 3.03488 5.63197 3.33335 6.00016 3.33335Z",
          fill: "#DD404F"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M4 1.33333H6V2.66667H4V1.33333Z", fill: "#FBAF29" }),
      /* @__PURE__ */ jsx("path", { d: "M6 2.66667H8V4H6V2.66667Z", fill: "#FBAF29" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 18.6667C7.10457 18.6667 8 18.0697 8 17.3333C8 16.597 7.10457 16 6 16C4.89543 16 4 16.597 4 17.3333C4 18.0697 4.89543 18.6667 6 18.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00016 18C6.36835 18 6.66683 17.7015 6.66683 17.3334C6.66683 16.9652 6.36835 16.6667 6.00016 16.6667C5.63197 16.6667 5.3335 16.9652 5.3335 17.3334C5.3335 17.7015 5.63197 18 6.00016 18Z",
          fill: "#DD404F"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M4 16H6V17.3333H4V16Z", fill: "#FBAF29" }),
      /* @__PURE__ */ jsx("path", { d: "M6 17.3333H8V18.6667H6V17.3333Z", fill: "#FBAF29" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 12C7.10457 12 8 11.403 8 10.6667C8 9.93029 7.10457 9.33333 6 9.33333C4.89543 9.33333 4 9.93029 4 10.6667C4 11.403 4.89543 12 6 12Z",
          fill: "#28AE67"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.99984 11.3334C6.73622 11.3334 7.33317 11.0349 7.33317 10.6667C7.33317 10.2985 6.73622 10 5.99984 10C5.26346 10 4.6665 10.2985 4.6665 10.6667C4.6665 11.0349 5.26346 11.3334 5.99984 11.3334Z",
          fill: "#DD404F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 14.6667C7.10457 14.6667 8 14.3682 8 14C8 13.6318 7.10457 13.3333 6 13.3333C4.89543 13.3333 4 13.6318 4 14C4 14.3682 4.89543 14.6667 6 14.6667Z",
          fill: "#28AE67"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 8C7.10457 8 8 7.40305 8 6.66667C8 5.93029 7.10457 5.33333 6 5.33333C4.89543 5.33333 4 5.93029 4 6.66667C4 7.40305 4.89543 8 6 8Z",
          fill: "#FBAF29"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00016 7.33335C6.36835 7.33335 6.66683 7.03488 6.66683 6.66669C6.66683 6.2985 6.36835 6.00002 6.00016 6.00002C5.63197 6.00002 5.3335 6.2985 5.3335 6.66669C5.3335 7.03488 5.63197 7.33335 6.00016 7.33335Z",
          fill: "#DD404F"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M4 5.33333H5.33333V8H4V5.33333Z", fill: "#28AE67" }),
      /* @__PURE__ */ jsx("path", { d: "M6.6665 5.33333H7.99984V8H6.6665V5.33333Z", fill: "#28AE67" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.8225 4.23818C14.5858 4.52023 14.6226 4.94073 14.9047 5.1774C15.1867 5.41407 15.6072 5.37728 15.8439 5.09523C16.0806 4.81318 16.0438 4.39267 15.7617 4.15601C15.4797 3.91934 15.0592 3.95613 14.8225 4.23818ZM13.0952 6.82267C12.8132 6.58601 12.3927 6.6228 12.156 6.90484C11.9193 7.18689 11.9561 7.6074 12.2382 7.84407C12.5202 8.08073 12.9407 8.04395 13.1774 7.7619C13.414 7.47985 13.3773 7.05934 13.0952 6.82267ZM11.7617 5.48934C11.4797 5.25267 11.0592 5.28946 10.8225 5.57151C10.5858 5.85356 10.6226 6.27407 10.9047 6.51073C11.1867 6.7474 11.6072 6.71061 11.8439 6.42856C12.0806 6.14651 12.0438 5.72601 11.7617 5.48934ZM14.4282 2.82267C14.1462 2.586 13.7257 2.62279 13.489 2.90484C13.2523 3.18689 13.2891 3.6074 13.5712 3.84407C13.8532 4.08073 14.2737 4.04394 14.5104 3.76189C14.7471 3.47984 14.7103 3.05934 14.4282 2.82267ZM13.7617 4.82267C13.4797 4.58601 13.0592 4.6228 12.8225 4.90484C12.5858 5.18689 12.6226 5.6074 12.9047 5.84407C13.1867 6.08073 13.6072 6.04394 13.8439 5.76189C14.0806 5.47985 14.0438 5.05934 13.7617 4.82267Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.4763 9.45051C15.8883 11.0386 13.3135 11.0386 11.7255 9.45051C11.5716 9.29664 11.4327 9.1335 11.3086 8.96288C12.8987 10.1191 15.1376 9.98015 16.5718 8.54598C18.006 7.11181 18.1449 4.8729 16.9887 3.28278C17.1593 3.40683 17.3225 3.5458 17.4763 3.69968C19.0644 5.28773 19.0644 7.86246 17.4763 9.45051Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagTmAsset = forwardRef(FlagTmAsset);

export { VpFlagTmAsset as default };
